export const CHATBOT_ENABLED_ROUTES = [
  '/',
  '/documents',
  '/transactions',
  '/results',
  '/support',
  '/support/search',
  '/support/categories',
  '/support/tutorials',
  '/support/tutorials/manual',
  '/profile/personal-data',
  '/profile/company-data/',
  '/profile/secondary-users',
  '/services/categories',
  '/services/categories/featured-offers',
  '/services/categories/online-store-solutions',
  '/services/categories/pos-solutions',
  '/services/categories/payment-solutions'
]
